import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import SimpleQuad from './components/SimpleQuad';
import SCSplit from './components/SCSplit';
import HelloWorld from './components/HelloWorld';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsalAuthentication, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus, InteractionType } from "@azure/msal-browser";
import { loginRequest } from './authConfig';
import chromeImage from './assets/chrome.png';
import edgeImage from './assets/edge.jpg';
import firefoxImage from './assets/firefox.png';
import operaImage from './assets/opera.jpg';
import Bowser from 'bowser';
import Modal from 'react-modal';
import LoginModal from './components/LoginModal';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import AuthenticationInProgress from './components/AuthenticationInProgress';



  // initializeIcons();  // only needed for modal log in button

  // Modal.setAppElement('#root');  // only needed for modal log in button


function App() {
  
  //  LOGIN BUTTON (HAVE TO LOG IN EACH TIME THE SITE IS LAUNCHED)
  
  /*
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthenticated) {
      setModalIsOpen(true);
    }
  }, [isAuthenticated]);

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<SCSplit />} />
          <Route path="/monitor-app-test" element={<SCSplit />} />
          <Route path="/quad" element={<SimpleQuad />} />
          <Route path="/hello" element={<HelloWorld />} />
        </Routes>
        {!isAuthenticated && (
          <LoginModal isOpen={modalIsOpen} onRequestClose={closeModal} />
        )}
      </div>
    </Router>
  );
  */



  //  INSTRUCTIONS FOR ENABLING POPUPS
  useMsalAuthentication(InteractionType.Popup, loginRequest);

  // Check if the authentication process is in progress or if the user is authenticated
  const isAuthenticated = useIsAuthenticated();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  
  
  useEffect(() => {
    if (!isAuthenticated) {
      setModalIsOpen(true);
    }
  }, [isAuthenticated]);

  const closeModal = () => {
    setModalIsOpen(false);
  };

 /*
  if (!isAuthenticated) {
    return (
      <AuthenticationInProgress />
     
    );
  }
    */

  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<SCSplit />} />
          <Route path="/monitor-app-test" element={<SCSplit />} />
          <Route path="/quad" element={<SimpleQuad />} />
          <Route path="/hello" element={<HelloWorld />} />
        </Routes>
        {!isAuthenticated && (
          <LoginModal isOpen={modalIsOpen} onRequestClose={closeModal} />
        )}
      </div>
    </Router>
  );
  



  //  ORIGINAL CODE
  /*
  // Automatically start the login process with a popup if not authenticated
  useMsalAuthentication(InteractionType.Popup, loginRequest);

  // Check if the authentication process is in progress or if the user is authenticated
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    return <span style={{ color: 'white', padding: '20px' }}>Authentication is currently in progress!</span>;
  }

  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<SCSplit />} />
          <Route path="/monitor-app-test" element={<SCSplit />} />
          <Route path="/quad" element={<SimpleQuad />} />
          <Route path="/hello" element={<HelloWorld />} />
        </Routes>
      </div>
    </Router>
  );
  */
}

export default App;
